import { TabletClosePortraitParams, TabletElements } from "../../types/index-type";
import { initQueryselectorTablet } from "../init-queryselector-tablet";


const isHTMLElement = (element: Element | null): element is HTMLElement =>
  element instanceof HTMLElement;

export const MovingGotoCloseTablet = ({
  wholeLeftPositionClosePortrait,
  sidebarColumnsPortrait,
  mainColumnsFillwidth,
}: TabletClosePortraitParams): void => {
  const { body, grid, sideBarButton, page }: TabletElements = initQueryselectorTablet();

  if (!isHTMLElement(grid) || !isHTMLElement(sideBarButton)) {
    return;
  }

  grid.style.left = `${wholeLeftPositionClosePortrait}vw`;
  grid.style.gridTemplateColumns = `${sidebarColumnsPortrait}vw ${mainColumnsFillwidth}vw`;

  if (isHTMLElement(page)) {
    page.style.width = "calc(100vw - 4vw)";
    page.style.transition = "0.5s";
  }

  grid.style.transition = "0.5s";

  sideBarButton.textContent = "OPEN";

  localStorage.setItem("toggleSlider", "close");

  if (isHTMLElement(body) && !body.style.opacity) {
    body.style.opacity = "1";
  }
};
